import type { ReactNode } from 'react';
import { HowToRead } from '../HowToRead';

/** Card wrapper giving every chart a title and a "How to read this" accordion (§10.4). */
export function ChartCard({
  title,
  help,
  children,
  footer,
}: {
  title: string;
  help: string;
  children: ReactNode;
  /** Optional caption rendered below the fixed-height chart area (kept out of it so it never overlaps). */
  footer?: ReactNode;
}) {
  return (
    <div className="break-inside-avoid rounded-lg border border-slate-200 bg-white p-3 shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <h3 className="mb-2 text-sm font-semibold text-slate-700 dark:text-slate-200">{title}</h3>
      <div className="h-64 w-full">{children}</div>
      {footer}
      <HowToRead text={help} />
    </div>
  );
}
